import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, MenuProps } from "antd";
import { Flex } from "antd"; // 假设你使用的是 antd 的 Flex 组件
import cls from "classnames"; // 假设你使用的是 classnames 库
import { useAtom, useSetAtom, useAtomValue } from "jotai";
import { EllipsisVertical, Pin } from "lucide-react";
import useRouteQuery from "@/hooks/useRouteQuery";
import styles from "./index.module.scss"; // 替换为你的样式文件路径
import LeftPanelWorkName from "@/components/LeftPanelWorkName";
import WorkDeleteModal from "@/components/WorkDeleteModal";
import useWork from "@/hooks/useWork";

import { workIdAtom, workSelectedAtom, workDataAtom } from "@/atom/drawBoard";

const WorkItem: React.FC<any> = ({ item, type, onDelete }: any) => {
  const isShareApp = type === "shareApp";
  const { shareId = "", workId = "" } = useRouteQuery();
  // 状态管理
  const [editor, setEditor] = useState(false);
  const [, setWorkId] = useAtom(workIdAtom);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const setWorkSelected = useSetAtom(workSelectedAtom);
  const workData = useAtomValue(workDataAtom);
  const { removeWork, makeWorkTop } = useWork();
  let navigate = useNavigate();

  // 菜单点击事件处理函数
  const handleMenuClick: MenuProps["onClick"] = async (e) => {
    setWorkSelected(item);
    if (e.key === "edit") {
      setEditor(true);
    } else if (e.key === "top") {
      makeWorkTop(item, item.position === "top" ? false : true);
    } else if (e.key === "delete") {
      setDeleteModalVisible(true);
    }
  };

  // 菜单配置
  const menu: MenuProps = {
    items: isShareApp
      ? [{ key: "delete", label: "删除", danger: true }]
      : [
          { key: "edit", label: "编辑名称" },
          { key: "top", label: item.position === "top" ? "取消置顶" : "置顶" },
          { key: "delete", label: "删除", danger: true },
        ],
    onClick: handleMenuClick,
  };

  const getName = () => {
    const name = item?.workName;
    if (isShareApp) {
      return (
        <>
          <img src={item.config?.shareImage} className={styles.icon} />
          {name}
        </>
      );
    }
    return name;
  };

  return (
    <div style={{ marginBottom: "5px" }}>
      <Flex
        justify="space-between"
        className={cls({
          [styles.workItem]: true,
          [styles.selected]: isShareApp
            ? item.shareId === shareId
            : item?.workId === workId &&
              window.location.pathname.includes("work"),
        })}
      >
        {/* 左侧面板工作名称组件 */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: editor ? "0px" : "0px 6px",
            flex: 1,
            minWidth: 0,
            margin: editor ? "-8px -12px" : "0",
          }}
          onClick={() => {
            if (isShareApp) {
              navigate(`/shareWork?shareId=${item.shareId}`);
            } else {
              navigate(`/work?workId=${item.workId}`, {
                state: {
                  workData: item,
                  source: 'controlPanel'
                }
              });
              setWorkSelected(item);
              setWorkId(item.workId);
              const url = new URL(window.location.href);
              url.searchParams.set("workId", item.workId);
              window.history.replaceState({}, "", url.toString());
            }
          }}
        >
          {!editor && item.position === "top" && (
            <Pin className={styles.pinIcon} />
          )}
          <LeftPanelWorkName
            workId={item?.workId}
            name={getName()}
            editor={editor}
            setEditor={setEditor}
          />
        </div>

        {/* 下拉菜单 */}
        {!editor && (
          <div className={styles.dropDown}>
            <Dropdown
              menu={menu}
              trigger={["click"]}
              placement="bottomLeft"
              align={{
                offset: [-55, 5], // 第一个值控制水平偏移，第二个值控制垂直偏移
              }}
              overlayClassName={styles.dropdownMenu}
            >
              <EllipsisVertical className={styles.workSetting} />
            </Dropdown>
          </div>
        )}
      </Flex>
      <WorkDeleteModal
        deleteModalVisible={deleteModalVisible}
        setDeleteModalVisible={setDeleteModalVisible}
        removeWork={onDelete || removeWork}
        workId={item?.workId}
      ></WorkDeleteModal>
    </div>
  );
};

export default WorkItem;